/* global angular */

export default function SectionController(
  $rootScope,

  editSectionDialog,
  loaderService,
  pmDataService,
  pmSharedModelService,
  previewTopSectionDialog,
  syncSectionCompareDialog,
  ssDialogService,
  alerts,
) {
  const vm = this;
  vm.handlePreview = _handlePreview;
  vm.handleEdit = _handleEdit;
  vm.handleSync = _handleSync;

  /** **************************************************
   * Event Handlers
   */

  function _handlePreview($event) {
    loaderService.showViewLoader = true;
    return pmDataService.getRenderedTopSection(vm.section.policyDocumentSectionId, true, true)
      .then((response) => {
        loaderService.showViewLoader = false;
        const renderedHtml = response.data.render;
        const sectionTitle = vm.section.title;
        return _showPreviewTopSectionDialog($event, { sectionTitle, renderedHtml });
      });
  }

  function _handleEdit($event) {
    loaderService.showViewLoader = true;
    return pmSharedModelService.getSection(vm.section.policyDocumentSectionId)
      .then((section) => {
        loaderService.showViewLoader = false;
        section.isSynced = vm.section.isSynced;
        angular.extend(vm.section, section);
        return _showEditSectionDialog($event, {
          policyDocumentId: vm.policyDocumentId,
          permissions: vm.permissions,
          section: vm.section
        });
      });
  }

  function _handleSync($event) {
/*
    loaderService.showViewLoader = true;

    pmSharedModelService.getCompareToMasterSection(
      vm.section.policyDocumentSectionId
    ).then((getChangesResponse) => {
      const data = getChangesResponse.data;

      ssDialogService.dialogs.pm.syncSectionCompareDialog = ssDialogService.alert(
        syncSectionCompareDialog.getOptions($event, {
          section: vm.section,
          changes: data.changes,
          changeArrays: data.changeArrays,
        })
      );

      return ssDialogService.show(ssDialogService.dialogs.pm.syncSectionCompareDialog);
    }).finally(() => {
      loaderService.showViewLoader = false;
    });

    /*/

    pmDataService.getCompareToMasterSection(
      vm.section.policyDocumentSectionId
    ).then((getChangesResponse) => {
      const changeArrays = getChangesResponse.data;
      const { deletedSectionIds, updatedSectionIds } = changeArrays;
      // loaderService.showViewLoader = false;
      let changeData;
      if (deletedSectionIds && deletedSectionIds.length > 0) {
        changeData = deletedSectionIds[0];
      } else if (updatedSectionIds && updatedSectionIds.length > 0) {
        changeData = updatedSectionIds[0];
      } else {
        alerts.error('Section could not be synced.');
        return;
      }
      const changes = {
        ...changeData,
        tokenizedCurrent: pmSharedModelService.replaceTokens(changeData.valueCurrent),
        tokenizedTo: pmSharedModelService.replaceTokens(changeData.valueTo),
      };

      ssDialogService.dialogs.pm.syncSectionCompareDialog = ssDialogService.alert(
        syncSectionCompareDialog.getOptions($event, {
          section: vm.section,
          changes,
          changeArrays,
        })
      );
      return ssDialogService.show(ssDialogService.dialogs.pm.syncSectionCompareDialog);
    }).finally(() => {
      loaderService.showViewLoader = false;
    });
  }

  /** **************************************************
   * Private Functions
   */

  function _showPreviewTopSectionDialog($event, locals) {
    ssDialogService.dialogs.pm.previewTopSectionDialog = ssDialogService.alert(
      previewTopSectionDialog.getOptions($event, locals)
    );
    return ssDialogService.show(ssDialogService.dialogs.pm.previewTopSectionDialog);
  }

  function _showEditSectionDialog($event, locals) {
    const dialogId = `editSectionDialog${locals.section.policyDocumentSectionId}`;
    ssDialogService.dialogs.pm[dialogId] = ssDialogService.alert(
      editSectionDialog.getOptions($event, locals)
    );
    return ssDialogService.show(ssDialogService.dialogs.pm[dialogId]);
  }
}

SectionController.$inject = [
  '$rootScope',

  'editSectionDialog',
  'loaderService',
  'pmDataService',
  'pmSharedModelService',
  'previewTopSectionDialog',
  'syncSectionCompareDialog',
  'ssDialogService',
  'alerts',
];
